import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import _ from 'lodash';

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import BeatLoader from 'react-spinners/BeatLoader';

import { getAllTimezones, getTimezone } from "countries-and-timezones"

import {
  DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton,
  GridColumnMenuContainer, SortGridMenuItems, GridFilterMenuItem, CustomUserItem
} from '@mui/x-data-grid-pro';

import Print from './Print';
import Export from './Export';
import Create from './Create';
import Update from './Update';
import ReImportPiceasoft from './ReImportPiceasoft';

import { useAppContext } from '../../../../Context/App/Provider';
import { get, create, update, remove, getLocationGetVersions, updateViews } from '../../../../Functions/admin';
import { useAdminContext } from '../../../../Context/Admin/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { colors, roles, useStateWithCallback, devicesTypeValues, toastTimerValue } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, activeGridFilter, setLocationGridValues, translatedGridFilters, getTimeAsZDateTime, getRandomPassword } from '../../../../Functions/utils';

import { updateLocationColumnsOrder, updateSavedLocations } from '../../../../Functions/user';
import { decodeHTMLEntities } from '../../../../Functions/utils';

import StatisticsDetails from './StatisticsDetails.js'

import '../Admin.css';
import '../../../SweetAlert.css'


export default function LocationsList() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();
  // const [{ locationColumns }, dispatch] = useAdminContext();

  const [{ settings, user }, appDispatch] = useAppContext();
  const [{ pickers, selected }, dispatch] = useReportingContext();
  const [{ groupsLocationsStatus, deploymentsStatus, scenariosStatus }, eventDispatch] = useEventContext();

  const [initialSelectedLocations, setInitialSelectedLocations] = useState(selected.locations);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingExtraColumns, setLoadingExtraColumns] = useState(true);

  // const [loadVersions, setLoadVersions] = useState(false);

  const [locations, setLocations] = useState([]);
  const [filterModel, setFilterModel] = useState({
    items: [],
    linkOperator: "and"
  });

  const [owners, setOwners] = useState([]);

  // const [filteredRows, setFilteredRows] = useState([]);

  const [databV2, setDatabV2] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationForReImportPiceasoft, setSelectedLocationForReImportPiceasoft] = useState(null);
  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });

  const [sortModel, setSortModel] = useState([]);
  const [currentMovedColumns, setCurrentMovedColumns] = useState([]);
  const [showStatistics, setShowStatistics] = useState(null);

  const [modeLocations, setModeLocations] = useState(
    settings.modeLocation === 'all_locations' ||
      settings.modeLocation === 'my_favorite_locations' ||
      settings.modeLocation === 'my_locations' ||
      settings.modeLocation === 'my_production_locations' ||
      settings.modeLocation === 'my_pilot_locations' ||
      settings.modeLocation === 'my_internal_locations' ||
      settings.modeLocation === 'all_production_locations' ||
      settings.modeLocation === 'all_pilot_locations' ||
      settings.modeLocation === 'all_internal_locations' ? settings.modeLocation : 'all_locations'
  );

  const CustomColumnMenu = (props) => {
    const { hideMenu, currentColumn, ...other } = props;

    return (
      <GridColumnMenuContainer
        hideMenu={hideMenu}
        currentColumn={currentColumn}
        {...props}
      >
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
      </GridColumnMenuContainer>
    );
  }

  const timeZones = getAllTimezones();
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [reordering, setReordering] = useState(null);
  const [reorderedColumn, setReorderedColumn] = useState("");

  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [locationColumnsFromDatabase, setLocationColumnsFromDatabase] = useState({});

  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const locationColumnsOrder = user.locationColumnsOrder ? JSON.parse(user.locationColumnsOrder) : {};

      const allLocationColumns = {
        id: { hide: true, order: 1, width: 100 },
        enabled: { hide: false, order: 2, width: 100 },
        type: { hide: false, order: 3, width: 140 },
        favorite: { hide: false, order: 4, width: 50 },
        deactivation: { hide: true, order: 5, width: 150 },
        status: { hide: true, order: 6, width: 150 },
        group: { hide: false, order: 7, width: 300 },
        label: { hide: false, order: 8, width: 400 },
        last: { hide: false, order: 9, width: 300 },
        name: { hide: false, order: 10, width: 350 },
        timezone: { hide: true, order: 11, width: 200 },
        sdsExpiration: { hide: true, order: 12, width: 200 },
        login: { hide: true, order: 13, width: 150 },
        password: { hide: true, order: 14, width: 150 },
        ip: { hide: true, order: 15, width: 150 },
        port: { hide: true, order: 16, width: 100 },
        dbType: { hide: false, order: 17, width: 125 },
        mobileProcessing: { hide: false, order: 18, width: 100 },
        piceasoft: { hide: false, order: 19, width: 100 },
        piceasoftId: { hide: true, order: 20, width: 400 },
        piceaApiKey: { hide: true, order: 21, width: 320 },
        piceasoftLastUpdate: { hide: true, order: 22, width: 300 },
        owner: { hide: false, order: 23, width: 350 },
        actions: { hide: false, order: 24, width: 180 }
      }

      for (const key of Object.keys(allLocationColumns)) {
        if (locationColumnsOrder[key]) {
          allLocationColumns[key] = locationColumnsOrder[key];
        }
      }

      const orderedKeys = Object.keys(allLocationColumns)
        .sort((a, b) => {
          return allLocationColumns[a].order > allLocationColumns[b].order ? 1 : -1;
        });

      let i = 1;
      for (const key of orderedKeys) {
        allLocationColumns[key].order = i;
        i++;
      }
      setLocationColumnsFromDatabase(allLocationColumns);
    }
  }, [loadedColumnsFromDatabase]);


  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);


  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
  }
  }, [reordering]);


  // const [locationColumnsFromDatabase, setLocationColumnsFromDatabase] = useState(
  //   user.locationColumnsOrder ?
  //     JSON.parse(user.locationColumnsOrder)
  //     :
  //     {
  //       id: { hide: true, order: 1, width: 100 },
  //       enabled: { hide: false, order: 2, width: 100 },
  //       favorite: { hide: false, order: 3, width: 50 },
  //       deactivation: { hide: true, order: 4, width: 150 },
  //       status: { hide: true, order: 5, width: 150 },
  //       group: { hide: false, order: 6, width: 300 },
  //       label: { hide: false, order: 7, width: 400 },
  //       last: { hide: false, order: 8, width: 300 },
  //       name: { hide: false, order: 9, width: 350 },
  //       timezone: { hide: true, order: 10, width: 200 },
  //       sdsExpiration: { hide: true, order: 11, width: 200 },
  //       login: { hide: true, order: 12, width: 150 },
  //       password: { hide: true, order: 13, width: 150 },
  //       ip: { hide: true, order: 14, width: 150 },
  //       port: { hide: true, order: 15, width: 100 },
  //       dbType: { hide: false, order: 16, width: 125 },
  //       mobileProcessing: { hide: false, order: 17, width: 100 },
  //       piceasoft: { hide: false, order: 18, width: 100 },
  //       piceasoftId: { hide: true, order: 19, width: 400 },
  //       piceasoftKey: { hide: true, order: 20, width: 320 },
  //       piceasoftLastUpdate: { hide: true, order: 21, width: 300 },
  //       owner: { hide: false, order: 22, width: 350 },
  //       actions: { hide: false, order: 23, width: 125 }
  //     }
  // );

  // console.log("119 - locationColumnsFromDatabase=", locationColumnsFromDatabase);

  let columns = [];
  if (locationColumnsFromDatabase.id) {
    columns = [ // default visible width: 1650
    {
      field: 'id',
      headerName: 'ID',
      hide: locationColumnsFromDatabase.id.hide,
      filterable: false,
      width: locationColumnsFromDatabase.id.width
    },
    {
        // sortable: false,
      field: 'enabled',
      type: 'activeFilter',
      hide: locationColumnsFromDatabase.enabled.hide,
      width: locationColumnsFromDatabase.enabled.width,
      headerName: t('admin.locations.columns.active'),

      renderCell: ({ row }) => {
        const icon = (
          <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
            <circle r={3.5} cx={5} cy={5} />
          </svg>
        );

        return (
          <Switch
            disabled={loading || loadingExtraColumns /*|| !row.exists*/}
            checked={row.enabled}
            onChange={() => toggleActivated(row)}
            offHandleColor="#888" onHandleColor="#080"

            checkedIcon={null} uncheckedIcon={null}
            checkedHandleIcon={icon} uncheckedHandleIcon={icon}
          />
        );
      }
    },
    {
        // sortable: false,
      field: 'favorite',
      hide: (locationColumnsFromDatabase.favorite && locationColumnsFromDatabase.favorite.hide) || false,
      width: (locationColumnsFromDatabase.favorite && locationColumnsFromDatabase.favorite.width) || 50,
      headerName: t('admin.groups.columns.favorite'),
      valueGetter: (params) => {
        return params.row.favoriteId !== null;
      },
      renderCell: ({ row }) => {
        return (
          <div>
            <Button
              className="button icon"
              title={t('global.favorite')}
              disabled={!row.enabled || loading || loadingExtraColumns}
              onClick={(e) => {
                e.stopPropagation();
                handleUpdateFavorite(e, row.id)
              }}
            >
              <span
                className={"material-icons"}
                style={{
                  textAlign: 'left',
                  fontSize: '20px',
                  padding: '0 0px',
                  color: row.favoriteId ? 'rgb(var(--favorite-color))' : 'rgb(var(--nofavorite-color))'
                }}
              >
                {row.favoriteId ? 'star' : 'star_border'}
              </span>
            </Button>
          </div>
        )
      }
    },
    {
        sortable: true,
        field: 'typePCMobiles',
        type: 'singleSelect',
        hide: locationColumnsFromDatabase.type ? locationColumnsFromDatabase.type.hide : false,
        width: locationColumnsFromDatabase.type ? locationColumnsFromDatabase.type.width : 70,
        headerName: t('admin.locations.columns.type'),
        valueOptions: [
          'PCs',
          'Mobiles',
          'PCs / Mobiles'
        ],
        valueGetter: (params) => {
          const laptop = (params.row.last && params.row.last !== "");
          const mobile = (params.row.lastMce && params.row.lastMce !== "");

          let value = "";
          if (laptop)
            value = "PCs";

          if (mobile) {
            if (value !== "")
              value = value + " / ";
            value = value + "Mobiles";
          }
          return value;

        },
        renderCell: ({ row }) => {
          const laptop = (row.last && row.last !== "");
          const mobile = (row.lastMce && row.lastMce !== "");
          return (
            <div>
              {laptop ?
                <span
                  className="material-icons"
                  title={t('scenarios.devicesType_PCs')}
                  style={{ height: 'auto', cursor: 'help' }}
                >laptop
                </span>
                : <></>
              }
              {mobile ?
                <span
                  className="material-icons"
                  title={t('scenarios.devicesType_mobiles')}
                  style={{ height: 'auto', cursor: 'help' }}
                >phone_iphone
                </span>
                : <></>
              }

            </div>
          )
        }
      },
      {
      field: 'deactivation',
      hide: locationColumnsFromDatabase.deactivation.hide,
      width: locationColumnsFromDatabase.deactivation.width,
      headerName: t('admin.locations.columns.deactivation')
    },
    ...(user.roleId <= roles.stAdmin ? [{
      field: 'status',
      type: 'singleSelect',
      headerName: t('admin.locations.columns.status'),
      hide: (locationColumnsFromDatabase.status && locationColumnsFromDatabase.status.hide) || false,
      width: (locationColumnsFromDatabase.status && locationColumnsFromDatabase.status.width) || 150,
      valueOptions: [
        t('admin.locations.status.production'),
        t('admin.locations.status.pilot'),
        t('admin.locations.status.internal'),
        t('admin.locations.status.not_set')
      ],
      valueGetter: (params) => {
        if (params.row.status)
          return t('admin.locations.status.' + params.row.status);
        return t('admin.locations.status.not_set');
      },
      renderCell: ({ row }) => {
        if (row.status) {
          return (
            <span>
              {t('admin.locations.status.' + row.status)}
            </span>
          )
        }
        else {
          return (
            <span style={{ opacity: '0.4' }}>
              {t('admin.locations.status.not_set')}
            </span>
          )
        }
      }
    }] : []),
    ...(user.roleId <= roles.stAdmin ? [{
      field: 'group', headerName: t('admin.locations.columns.group'), hide: locationColumnsFromDatabase.group.hide, width: locationColumnsFromDatabase.group.width
    }] : []),
    {
      field: 'label',
      hide: locationColumnsFromDatabase.label.hide,
      width: locationColumnsFromDatabase.label.width,
      headerName: t('admin.locations.columns.label')
    },
	
    { //new Date(getTimeAsZDateTime(deployment.date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
      field: 'last',
      hide: locationColumnsFromDatabase.last.hide,
      width: locationColumnsFromDatabase.last.width,
      headerName: t('admin.locations.columns.last'),
      align: 'left',
      headerAlign: 'left',
      type: 'date',
      renderCell: ({ row }) => {
        
        let lastTxt = (row.last) ? new Date(getTimeAsZDateTime(row.last)).toLocaleDateString(settings.lang ? settings.lang : 'en', options) : "...";
        if (row.last && row.timezone) {        
          let tz = getTimezone(row.timezone);
          let tmpLast = row.last.slice(0, row.last.length - 1);
          const localDate = new Date(tmpLast + tz.utcOffsetStr).toLocaleString("en-US", options);

          const localLastTxt = new Date(localDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);          
          lastTxt = localLastTxt;
        }

        if (
          (row.last && row.last !== '')
        )
          return (
            <div>
              {lastTxt}
            </div>
          )

        return (
          <div>
            ...
          </div>
        )
      }
      // valueGetter: (params) => {
      //   if (params.row.last && params.row.last !== '')
      //     return new Date(getTimeAsZDateTime(params.row.last)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
      //   else
      //     return '...';
      // }
    },
    {
      field: 'name',
      hide: locationColumnsFromDatabase.name.hide,
      width: locationColumnsFromDatabase.name.width,
      headerName: t('admin.locations.columns.name'),
      renderCell: ({ row }) => {

        // console.log("315 - row=", row);
        let piceaErrorMessage = "";
        if (row.piceaLastError !== "0" && row.piceaLastError !== 0) {
          piceaErrorMessage = t(`piceasoft_api_status_code.piceasoft_api_error`)
            + ' : "'
            + t(`piceasoft_api_status_code.${row.piceaLastError}`)
            + '" ('
            + new Date(getTimeAsZDateTime(row.piceaLastErrorDate)).toLocaleDateString(settings.lang ? settings.lang : 'en')
            + ') ';
        }


        if (row.exists) {
          return (
            <div>
              {row.piceaLastError !== "0" && row.piceaLastError !== 0 && row.piceaLastError !== null && row.piceaLastError !== undefined && (
                <span
                  title={piceaErrorMessage}
                  onClick={e => {
                    let forceDisabled = false;
                    if (row.owner !== null && user.roleId >= roles.stAdmin) {
                      forceDisabled = true;
                      if (row.owner === user.id)
                        forceDisabled = false;
                    }
                    if (!forceDisabled && row.exists)
                      setSelectedLocation(row);
                  }}
                  className="material-icons"
                  style={{ color: '#ff0000', verticalAlign: 'text-bottom' }}
                >
                  warning_amber
                  &nbsp;
                </span>
              )}

              {row.name}
            </div>
          )
        }
        return (
          <div title={t('admin.locations.errors.exists')}>
            <span
              onClick={e => databaseCreationConfirmation(row)}
              className="material-icons"
              style={{ color: '#ffa600', verticalAlign: 'text-bottom' }}
            >
              warning_amber
              &nbsp;
            </span>

            {row.piceaLastError !== 0 && row.piceaLastError !== null && row.piceaLastError !== undefined && (
              <span
                title={piceaErrorMessage}
                onClick={e => {
                  let forceDisabled = false;
                  if (row.owner !== null && user.roleId >= roles.stAdmin) {
                    forceDisabled = true;
                    if (row.owner === user.id)
                      forceDisabled = false;
                  }
                  if (!forceDisabled && row.exists)
                    setSelectedLocation(row);
                }}
                className="material-icons"
                style={{ color: '#ff0000', verticalAlign: 'text-bottom' }}
              >
                warning_amber
            &nbsp;
              </span>
            )}

            {row.name}
          </div>
        )
      }
    },
    {
      field: 'timezone',
      hide: (locationColumnsFromDatabase.timezone && locationColumnsFromDatabase.timezone.hide) || false,
      width: (locationColumnsFromDatabase.timezone && locationColumnsFromDatabase.timezone.width) || 200,
      headerName: t('admin.locations.columns.timezone')
    },
    // {
    //   field: 'mceLocation',
    //   hide: locationColumns.mceLocation.hide,
    //   width: locationColumns.mceLocation.width,
    //   headerName: t('admin.locations.columns.mce_location')
    // },
    // {
    //   field: 'mceProductKey',
    //   hide: locationColumns.mceProductKey.hide,
    //   width: locationColumns.mceProductKey.width,
    //   headerName: t('admin.locations.columns.mce_product_key')
    // },
    // {
    //   field: 'mceExpiration',
    //   hide: locationColumns.mceExpiration.hide,
    //   width: locationColumns.mceExpiration.width,
    //   headerName: t('admin.locations.columns.mce_expiration')
    // },
    {
      field: 'sdsExpiration',
      hide: locationColumnsFromDatabase.sdsExpiration.hide,
      width: locationColumnsFromDatabase.sdsExpiration.width,
      headerName: t('admin.locations.columns.sds_expiration')
    },

    ...(user.roleId <= roles.stAdmin ? [{
      field: 'login',
      headerName: t('admin.locations.columns.login'),
      hide: locationColumnsFromDatabase.login.hide,
      width: locationColumnsFromDatabase.login.width
    },
    {
      field: 'password',
      headerName: t('admin.locations.columns.password'),
      hide: locationColumnsFromDatabase.password.hide,
      width: locationColumnsFromDatabase.password.width
    }
    ] : []),

    {
      field: 'ip',
      sortable: false,
      hide: locationColumnsFromDatabase.ip.hide,
      width: locationColumnsFromDatabase.ip.width,
      headerName: t('admin.locations.columns.ip')
    },
    {
      field: 'port',
      sortable: false,
      hide: locationColumnsFromDatabase.port.hide,
      width: locationColumnsFromDatabase.port.width,
      headerName: t('admin.locations.columns.port')
    },
    {
      field: 'dbType',
      hide: locationColumnsFromDatabase.dbType.hide,
      width: locationColumnsFromDatabase.dbType.width,
      headerName: t('admin.locations.columns.db_type')
    },
    {
      field: 'owner',
      hide: locationColumnsFromDatabase.owner.hide,
      width: locationColumnsFromDatabase.owner.width,
      headerName: t('admin.locations.columns.creator'),
      valueGetter: (params) => {
        return params.row.email;
      }
    },
    
    {
      field: 'mobileProcessing',
      hide: (locationColumnsFromDatabase.mobileProcessing && locationColumnsFromDatabase.mobileProcessing.hide) || false,
      width:  (locationColumnsFromDatabase.mobileProcessing && locationColumnsFromDatabase.mobileProcessing.hide) || 200,
      headerName: t('admin.locations.columns.mobileProcessing'),
      valueGetter: (params) => {
        return params.row.mobileProcess;
      },
      renderCell: ({ row }) => {
        if (row.mobileProcess){
          return (
            <span className="material-icons">check</span>
          )
        }
        else {
          return (
            <></>
          )
        }
      }
    },
    {
      field: 'piceasoft',
      hide: (locationColumnsFromDatabase.piceasoft && locationColumnsFromDatabase.piceasoft.hide) || false,
      width:  (locationColumnsFromDatabase.piceasoft && locationColumnsFromDatabase.piceasoft.hide) || 150,
      headerName: t('admin.locations.columns.piceasoftCheck'),
      valueGetter: (params) => {
        return params.row.piceasoftCheck;
      },
      renderCell: ({ row }) => {
        if (row.piceasoftCheck){
          return (
            <span className="material-icons">check</span>
          )
        }
        else {
          return (
            <></>
          )
        }
      }
    },
    {
      field: 'piceasoftId',
      hide: (locationColumnsFromDatabase.piceasoftId && locationColumnsFromDatabase.piceasoftId.hide) || false,
      width:  (locationColumnsFromDatabase.piceasoftId && locationColumnsFromDatabase.piceasoftId.hide) || 320,
      headerName: t('admin.locations.columns.piceasoft_id'),
      valueGetter: (params) => {
        return params.row.piceaApiId;
      }
    },
    {
      field: 'piceaApiKey',
      hide: (locationColumnsFromDatabase.piceaApiKey && locationColumnsFromDatabase.piceaApiKey.hide) || false,
      width:  (locationColumnsFromDatabase.piceaApiKey && locationColumnsFromDatabase.piceaApiKey.hide) || 300,
      headerName: t('admin.locations.columns.piceasoft_key'),
      valueGetter: (params) => {
        return params.row.piceaApiKey;
      }
    },
    { 
      field: 'piceasoftLastUpdate',
      hide: (locationColumnsFromDatabase.piceasoftLastUpdate && locationColumnsFromDatabase.piceasoftLastUpdate.hide) || false,
      width:  (locationColumnsFromDatabase.piceasoftLastUpdate && locationColumnsFromDatabase.piceasoftLastUpdate.hide) || 300,
      headerName: t('admin.locations.columns.piceasoft_lastupdate'),
      align: 'left',
      headerAlign: 'left',
      type: 'date',
      renderCell: ({ row }) => {
        const lastTxt = (row.piceaLastUpdateDate) ? new Date(getTimeAsZDateTime(row.piceaLastUpdateDate)).toLocaleDateString(settings.lang ? settings.lang : 'en', options) : "...";

        if (
          (row.piceaApiKey && row.piceaLastUpdateDate && row.piceaLastUpdateDate !== '')
        )
          return (
            <div>
              {lastTxt}
            </div>
          )

        return (
          <div>
            ...
          </div>
        )
      }
    },

    // {
    //   field: 'activityPc',
    //   hide: locationColumns.activityPc.hide,
    //   width: locationColumns.activityPc.width,
    //   headerName: t('admin.locations.columns.activity_pc')
    // },
    // {
    //   field: 'activityMobile',
    //   hide: locationColumns.activityMobile.hide,
    //   width: locationColumns.activityMobile.width,
    //   headerName: t('admin.locations.columns.activity_mobile')
    // },
    {
      field: 'actions',
      headerName: 'Actions',
      hide: locationColumnsFromDatabase.actions.hide,
        width: Math.max(180, locationColumnsFromDatabase.actions.width),

      sortable: false,
      filterable: false,

      align: 'right',
      headerAlign: 'right',

      renderCell: ({ row }) => {

        let forceDisabled = false;
        if (row.owner !== null && user.roleId >= roles.stAdmin) {
          forceDisabled = true;
          if (row.owner === user.id)
            forceDisabled = false;
        }

        return (
        <div>
          <Button
              disabled={loading || loadingExtraColumns || forceDisabled}
            title={t('global.update')}
            style={{ minWidth: 'unset' }}
            onClick={() => {
              if (row.exists) {
                return setSelectedLocation(row);
              }
              else {
                return databaseCreationConfirmation(row);
              }
            }}
          >
            <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
          </Button>

          <Button
              disabled={loading || loadingExtraColumns || forceDisabled}
            title={t('global.delete')}
            style={{ minWidth: 'unset' }}
            onClick={() => handleDelete(row)}
          >
            <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
          </Button>

            <Button
              disabled={loading || loadingExtraColumns}
              title={t('global.statistics')}
              style={{ minWidth: 'unset' }}
              onClick={() => setShowStatistics(row)}
            >
              <span className="material-icons-outlined" style={{ color: '#222' }}>insert_chart</span>
            </Button>

              <Button
                disabled={loading || loadingExtraColumns || forceDisabled || !row.piceasoftCheck}
                title={t('global.refresh_piceasoft')}
                style={{ minWidth: 'unset' }}
                onClick={()  => { return setSelectedLocationForReImportPiceasoft(row);}}
              >
                <span className="material-icons-outlined" style={{ opacity: row.piceasoftCheck ? 1 : 0, color: '#222' }}>refresh</span>
              </Button>
        </div>
      )
    }
    },
    // ...(!loading && loadingExtraColumns ? [{
    //   field: 'loading',
    //   headerName: t('admin.locations.columns.modules_version'),
    //   align: 'center',
    //   headerAlign: 'left',
    //   hide: false,
    //   width: 250,
    //   renderCell: ({ row }) => {
    //     return (
    //       <BeatLoader color={colors.softthinks} />
    //     )
    //   }
    // }] : []),
  ] // Keep columns order between sessions
      //.sort((a, b) => locationColumnsFromDatabase[a.field] && locationColumnsFromDatabase[b.field] ? locationColumnsFromDatabase[a.field].order - locationColumnsFromDatabase[b.field].order : 0);
      .sort((a, b) => {
        // console.log("731 - a=", a, locationColumnsFromDatabase[a.field], locationColumnsFromDatabase[a.field] && locationColumnsFromDatabase[a.field].order);
        if (locationColumnsFromDatabase[a.field] && locationColumnsFromDatabase[b.field])
          return locationColumnsFromDatabase[a.field].order - locationColumnsFromDatabase[b.field].order;
        return -1;
      });
    }

  const databaseCreationConfirmation = (loc, activate = false) => {
    // console.log("264 - databaseCreationConfirmation=", loc);

    // Swal({
    //   title: t('global.dialog_title'),
    //   text: t("admin.locations.creation_confirm"),
    //   // icon: "warning",
    //   buttons: {
    //     confirm: {
    //       text: t("global.yes"),
    //       value: true,
    //       visible: true,
    //       className: "btnPrimary",
    //       closeModal: true
    //     },
    //     cancel: {
    //       text: t("global.no"),
    //       value: false,
    //       visible: true,
    //       className: "btnSecondary",
    //       closeModal: true,
    //     }
    //   },
    //   closeOnClickOutside: false
    // }).then((value) => {

    //   if (value) {

    //     const strTmp = loc.name.replaceAll(/[^a-zA-Z0-9\d]/g, '_');
    //     const login = strTmp + '_SDS_User';
    //     const password = getRandomPassword();

    //     // console.log("313 - login=", login);
    //     // console.log("314 - password=", password);
    //     // console.log("315 - loc.name=", loc.name);

    //     let databaseData = {
    //       ...loc,
    //       new: true,
    //       login: login,
    //       password: password,
    //       dbType: loc.dbType === 'SDS' ? 1 : 2,
    //       activityPc: loc.activityPc === 'Yes',
    //       activityMobile: loc.activityMobile === 'Yes'
    //     };

    //     if (activate === true) {
    //       databaseData = {
    //         ...databaseData,
    //         enabled: true
    //       }
    //     }

    //     setLoading(true);
    //     create({ type: 'database', database: databaseData }).then(res => {

    //       if (!res.success) {
    //         setLoading(false);
    //         return toast(t('admin.database.errors.' + res, { name: loc.name }), { type: 'error' });
    //       }

    //       toast(t('admin.database.create.success', { name: loc.label }), { type: 'success' });

    //       update({ type: 'location', location: databaseData }).then(res2 => {
    //         setLoading(false);

    //         if (!res2.success) return toast(t('admin.locations.errors.' + res2, { name: databaseData.label }), { type: 'error' });

    //         const newLocations = locations.concat(setLocationGridValues(t, res2.location, groups));
    //         setLocations(newLocations.sort((a, b) => a.label.localeCompare(b.label)));

    //         setSelectedLocation(null);
    //         toast(t('admin.locations.relink.success', { name: databaseData.label }), { type: 'success' });

    //         setDatabV2([]);
    //         appDispatch({ forceReload: true, forceReloadScenario: true });
    //         eventDispatch({ groupsLocationsStatus: 'pending' });
    //       });
    //     });
    //   }
    // });

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t("admin.locations.creation_confirm"),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {

      // console.log("454 - value=", value);
      if (value && value.isConfirmed) {

        const strTmp = loc.name.replaceAll(/[^a-zA-Z0-9\d]/g, '_');
        const login = strTmp + '_SDS_User';
        const password = getRandomPassword();

        // console.log("313 - login=", login);
        // console.log("314 - password=", password);
        // console.log("315 - loc.name=", loc.name);

        let databaseData = {
          ...loc,
          new: true,
          login: login,
          password: password,
          dbType: loc.dbType === 'SDS' ? 1 : 2,
          activityPc: loc.activityPc === 'Yes',
          activityMobile: loc.activityMobile === 'Yes'
        };

        if (activate === true) {
          databaseData = {
            ...databaseData,
            enabled: true
          }
        }

        setLoading(true);
        create({ type: 'database', database: databaseData }).then(res => {

          if (!res.success) {
            setLoading(false);
            return toast(decodeHTMLEntities(t('admin.database.errors.' + res, { name: loc.name })), { type: 'error' });
          }

          toast(decodeHTMLEntities(t('admin.database.create.success', { name: loc.label })), { type: 'success' });

          update({ type: 'location', location: databaseData }).then(res2 => {
            setLoading(false);

            if (!res2.success) {
              return toast(decodeHTMLEntities(t('admin.locations.errors.' + res2, { name: databaseData.label })), { type: 'error' });
            }

            const newLocations = locations.concat(setLocationGridValues(t, res2.location, groups));
            setLocations(newLocations.sort((a, b) => a.label.localeCompare(b.label)));

            setSelectedLocation(null);
            toast(decodeHTMLEntities(t('admin.locations.relink.success', { name: databaseData.label })), { type: 'success' });

            setDatabV2([]);
            appDispatch({ forceReload: true, forceReloadScenario: true });
            eventDispatch({ groupsLocationsStatus: 'pending' });
          });
        });
      }
    });
  };


  const toggleActivated = (loc) => {

    if (loc.exists) {
    setLoading(true);

    loc.enabled = !loc.enabled;
    const location = { id: loc.id, skip: true, enabled: loc.enabled };

      // console.log("445 - update location=", location);

    update({ type: 'location', location }).then(res => {
      setLoading(false);
      if (!res.success) {
        loc.enabled = !loc.enabled; // revert switch state if error
          return toast(decodeHTMLEntities(t('admin.locations.errors.' + res, { name: loc.label })), { type: 'error' });
      }
        const savedLocations = selected.locations;
        const newSavedLocations = savedLocations.filter(location => location.value !== loc.id);
        const savedLocationsChanged = !_.isEqual(savedLocations, newSavedLocations);

        // console.log("464 - savedLocations=", savedLocations);
        // console.log("465 - newSavedLocations=", newSavedLocations);
        // console.log("466 - savedLocationsChanged=", savedLocationsChanged);
        // console.log("467 - loc.enabled=", loc.enabled);

        if (savedLocationsChanged && !loc.enabled) {
          updateSavedLocations(JSON.stringify(newSavedLocations));

          if (settings.mode === 'modules')
            eventDispatch({ groupsLocationsStatus: 'force', deploymentsStatus: 'pending' });
          else {
            eventDispatch({ groupsLocationsStatus: 'force', scenariosStatus: 'pending' });
          }
        }
        else {
          eventDispatch({ groupsLocationsStatus: 'force' });
        }
        // console.log("480 - update location DONE");

        // toast({
        //   data:
        //     <p>
        //       {t('admin.locations.' + (res.location.enabled ? 'activated' : 'deactivated'), { name: loc.label })}
        //     </p>
        // },
        //   { type: 'success' }
        // );

        toast(decodeHTMLEntities(t('admin.locations.' + (res.location.enabled ? 'activated' : 'deactivated'), { name: loc.label })), { type: 'success' });

        // Swal.fire({
        //   toast: true,
        //   icon: 'success',
        //   title: t('admin.locations.' + (res.location.enabled ? 'activated' : 'deactivated'), { name: loc.label }),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
    });
    }
    else {
      return databaseCreationConfirmation(loc, true);
    }
  };


  const handleUpdateFavorite = (e, location) => {
    e.preventDefault();

    const favorite = { locationId: location };
    let tmpArray = new Array();
    for (const loc of locations) {
      const tmpLoc = {
        ...loc
      }
      if (loc.id == location) {
        if (loc.favoriteId)
          tmpLoc.favoriteId = null;
        else
          tmpLoc.favoriteId = 'fake';
      }
      tmpArray.push(tmpLoc);
    }
    setLocations(tmpArray);

    try {
      update({ type: 'favorite', favorite }).then(res => {
        // appDispatch({ forceReload: true, forceReloadScenario: true });
        // eventDispatch({ groupsLocationsStatus: 'pending' });
      });

      const newUser = {
        ...user,
        locations: tmpArray
      }
      appDispatch({ user: newUser });
    }
    catch (error) {
      console.log("681 - error=", error);
    }
  };

  // const handleShowStatistics = (loc) => {
  // }

  const handleDelete = (loc) => {
    // const input = window.prompt(t('admin.locations.delete.confirm')+ ' ('+loc.label+')');
    //const input = window.prompt(t('admin.locations.delete.confirm', { name: loc.label }))

    let newText = loc.label.replace(/ /g, ' ');

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.locations.delete.confirm', { name: newText }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
        const newLabel = loc.label.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
        if (newValue != newLabel && value != loc.label && newValue != loc.label) {   // CHECK loc.label === value
          return t('admin.locations.delete.validation');
        }
        return "";
        },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {
      // console.log("589 - value=", value);

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
        const newLabel = loc && loc.label && loc.label.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
        if (newValue === newLabel || value === loc.label || newValue === loc.label) {   // CHECK loc.label === value
      setLoading(true);

      remove({ type: 'location', id: loc.id }).then(res => {
        setLoading(false);
            if (!res.success) {
              return toast(decodeHTMLEntities(t('admin.locations.errors.' + res, { name: loc.label })), { type: 'error' });

            }

        setLocations(locations.filter(row => row.id !== loc.id));
            toast(decodeHTMLEntities(t('admin.locations.delete.success', { name: loc.label })), { type: 'success' });

        setDatabV2([]);

            const savedLocations = JSON.parse(user.savedLocations);
            const newSavedLocations = savedLocations.filter(location => location !== loc.id);
            const savedLocationsChanged = !_.isEqual(savedLocations, newSavedLocations);

            if (savedLocationsChanged) {
              updateSavedLocations(JSON.stringify(newSavedLocations));

              if (settings.mode === 'modules')
                eventDispatch({ groupsLocationsStatus: 'force', deploymentsStatus: 'pending' });
              else {
                eventDispatch({ groupsLocationsStatus: 'force', scenariosStatus: 'pending' });
              }
            }
            else {
              eventDispatch({ groupsLocationsStatus: 'force' });
            }
      });
    }
      }

      // if (value) {
      //   const swalState = Swal.getState();

      //   console.log("534 - swalState.actions.confirm.value=", swalState.actions.confirm.value);
      //   console.log("535 - loc.label=", loc.label);

      //   // if (swalState && swalState.actions && swalState.actions.confirm && swalState.actions.confirm.value === loc.label) {

      //   if (swalState && swalState.actions && swalState.actions.confirm) {

      //     const newValue = swalState.actions.confirm.value.replace(/ /g, ' ');
      //     if (newValue === loc.label) {
      //       setLoading(true);

      //       remove({ type: 'location', id: loc.id }).then(res => {
      //         setLoading(false);
      //         if (!res.success) return toast(t('admin.locations.errors.' + res, { name: loc.label }), { type: 'error' });

      //         setLocations(locations.filter(row => row.id !== loc.id));
      //         toast(t('admin.locations.delete.success', { name: loc.label }), { type: 'success' });

      //         setDatabV2([]);
      //         // appDispatch({ forceReload: true, forceReloadScenario: true });
      //         // eventDispatch({ groupsLocationsStatus: 'pending' });

      //         const savedLocations = JSON.parse(user.savedLocations);
      //         const newSavedLocations = savedLocations.filter(location => location !== loc.id);
      //         const savedLocationsChanged = !_.isEqual(savedLocations, newSavedLocations);

      //         if (savedLocationsChanged) {
      //           updateSavedLocations(JSON.stringify(newSavedLocations));

      //           if (settings.mode === 'modules')
      //             eventDispatch({ groupsLocationsStatus: 'force', deploymentsStatus: 'pending' });
      //           else {
      //             eventDispatch({ groupsLocationsStatus: 'force', scenariosStatus: 'pending' });
      //           }
      //         }
      //         else {
      //           eventDispatch({ groupsLocationsStatus: 'force' });
      //         }
      //       });
      //     }
      //     else {
      //       return toast(t('admin.locations.errors.wrong'), { type: 'error' });
      //     }
      //   }
      // }
    });

    // if (input === loc.label) {
    //   setLoading(true);

    //   remove({ type: 'location', id: loc.id }).then(res => {
    //     setLoading(false);
    //     if (!res.success) return toast(t('admin.locations.errors.' + res, { name: loc.label }), { type: 'error' });

    //     setLocations(locations.filter(row => row.id !== loc.id));
    //     toast(t('admin.locations.delete.success', { name: loc.label }), { type: 'success' });

    //     setDatabV2([]);
    //     appDispatch({ forceReload: true });
    //   });
    // }

    // else if (input) return toast(t('admin.locations.errors.wrong'), { type: 'error' });
  };

  const handleSortChange = (model) => {
    /* if statement to prevent the infinite loop by confirming model is 
     different than the current sortModel state */
    if (JSON.stringify(model) !== JSON.stringify(sortModel)) {
      setSortModel(model);
    }
  };


  const handleSetModeLocations = (mode) => {
    setModeLocations(mode);
    changeSettings(t, 'modeLocation', mode, settings, appDispatch);
    document.querySelector('#modeLocations').classList.toggle('open');
  };


  const selectedOption = () => {
    if (!selectedLocation) return null;

    // determine if user wants to create or edit a location
    return selectedLocation.id ? (
      <Update
        groups={groups}
        locations={locations}
        setLocations={setLocations}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        databV2={databV2}
        setDatabV2={setDatabV2}
        owners={owners}
      />
    ) : (
      <Create
        groups={groups}
        locations={locations}
        setLocations={setLocations}
        setSelectedLocation={setSelectedLocation}
        databV2={databV2}
        setDatabV2={setDatabV2}
        owners={owners}
      />
    )
  };

  const selectedReImportPiceasoft = () => {
    if (!selectedLocationForReImportPiceasoft) return null;

    return (
      <ReImportPiceasoft
        groups={groups}
        locations={locations}
        selectedLocationForReImportPiceasoft={selectedLocationForReImportPiceasoft}
        setSelectedLocationForReImportPiceasoft={setSelectedLocationForReImportPiceasoft}
      />
    );
  };

  const changeColumnsWidth = (col) => {
    // console.log("629 - changeColumnsWidth=", col);
    const prev = JSON.stringify(locationColumnsFromDatabase);
    let newLocationColumns = locationColumnsFromDatabase;

    if (newLocationColumns[col.colDef.field]) {
    newLocationColumns[col.colDef.field].width = col.width;
    const next = JSON.stringify(newLocationColumns);

    if (prev !== next) {
      updateLocationColumnsOrder(newLocationColumns);
      setLocationColumnsFromDatabase(newLocationColumns);

        const newUser = {
          ...user,
          locationColumnsOrder: next
        }
        appDispatch({ user: newUser });
      }
    }
  }


  const changeColumnsVisibility = (col) => {
    // console.log("652 - changeColumnsVisibility=", col);
    const prev = JSON.stringify(locationColumnsFromDatabase);
    let newLocationColumns = locationColumnsFromDatabase;

    if (newLocationColumns[col.colDef.field]) {
    newLocationColumns[col.colDef.field].hide = !col.isVisible;
    const next = JSON.stringify(newLocationColumns);

    if (prev !== next) {
      updateLocationColumnsOrder(newLocationColumns);
      setLocationColumnsFromDatabase(newLocationColumns);

        const newUser = {
          ...user,
          locationColumnsOrder: next
        }
        appDispatch({ user: newUser });
      }
    }
  }

  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {

    const prev = JSON.stringify(locationColumnsFromDatabase);

    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newLocationColumns = {};
    for (const columnName in locationColumnsFromDatabase) {
      const column = locationColumnsFromDatabase[columnName];

      newLocationColumns[columnName] = locationColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newLocationColumns[columnName].order = newLocationColumns[columnName].order + ecart;
        }
    const orderedKeys = Object.keys(newLocationColumns)
      .sort((a, b) => {
        return newLocationColumns[a].order > newLocationColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newLocationColumns[key].order = i;
      i++;
    }
    const next = JSON.stringify(newLocationColumns);


    if (prev !== next) {
      updateLocationColumnsOrder(newLocationColumns);
      setLocationColumnsFromDatabase(newLocationColumns);

      const newUser = {
        ...user,
        locationColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }

  const rowsToPrint = () => {
    const filtered = model.filtered ?? locations;

    // .slice() creates a new array
    const rows = filtered.slice().filter(loc => (
      model.selected.length > 0 ? model.selected.includes(loc.id) : loc.id > 0
    ));

    return rows;
  };

  const updateRowsAndPrint = () => {
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => window.print()
    );
  };


  useEffect(() => {
    // console.log("1343 - useEffect... locations=", locations);
    document.title = t('admin.locations.page');

    if (locations.length === 0) {
      get({ type: 'location' }).then(res => {
      setLoading(false);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('admin.locations.errors.' + res)), { type: 'error' });
        }

      const newLocations = [];
      for (const location of res.locations) { // Add group name in the table
        newLocations.push(setLocationGridValues(t, location, res.groups));
      };

      setGroups(res.groups);
      // setLocations(newLocations);
      setLocations(newLocations.sort(function (a, b) {
        if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
          return -1;
        }
        if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
          return 1;
        }

        if (a.label && b.label && a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        return 1;
        }));

        // setLoadVersions(true);

        setLoadingExtraColumns(true);
        getLocationGetVersions().then(res => {
          setLoadingExtraColumns(false);
          if (res.success) {

            const newLocations = [];
            for (const location of res.locations) { // Add group name in the table
              newLocations.push(setLocationGridValues(t, location, res.groups));
            };

            setLocations(newLocations.sort(function (a, b) {
              if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
                return -1;
              }
              if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
                return 1;
              }

              if (a.label && b.label && a.label.toLowerCase() < b.label.toLowerCase()) {
                return -1;
              }
              return 1;
            }));
          }
        });
    });
    }
  }, [t, locations]);


  useEffect(() => {
    document.title = t('admin.locations.page');

    if (owners.length === 0) {
      get({ type: 'user' }).then(res => {
        if (!res.success) {
          return toast(decodeHTMLEntities(t('admin.users.errors.' + res)), { type: 'error' });
        }

        let ownersTmp = res.users.map(
          ({ id, email, roleId, isActivated }) => ({ id, email, roleId, isActivated })
        ).filter(user => (
          user.roleId <= roles.stAdmin && user.isActivated
        )).sort(function (a, b) {
          if (a.roleId < b.roleId) {
            return -1;
          }
          if (a.roleId > b.roleId) {
            return 1;
          }
          if (a.email.toLowerCase() < b.email.toLowerCase()) {
            return -1;
          }
          if (b.email.toLowerCase() < a.email.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        // console.log("1502 - ownersTmp=", ownersTmp);
        setOwners(ownersTmp);
      });
    }
  }, [t, owners]);



  useEffect(() => {
    // console.log("774 - useEffect... databV2=", databV2);
    document.title = t('admin.locations.page');

    if (databV2.length === undefined || databV2.length === 0) get({ type: 'databV2' }).then(resV2 => {

      // console.log("351 - resV2=", resV2);
      if (resV2.success) {

        // console.log("353 - resV2.databV2=", resV2.databV2);

        if (resV2.databV2.length === 0) {
          const data = {
            id: "FAKE_EmptyData",
            name: ""
          }
          const tmpDatabV2 = [];
          tmpDatabV2.push(data);
          setDatabV2(tmpDatabV2);
        }
        else {
        setDatabV2(resV2.databV2.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (b.name.toLowerCase() < a.name.toLowerCase()) {
            return 1;
          }
          return 0;
        }));
      }
      }
    });
  }, [t, databV2]);


  // console.log("1528 - locations=", locations);
  // console.log("370 - databV2=", databV2);
  // console.log("383 - sortModel=", sortModel);

  // columns.
  let numOrder = columns.length + 1;
  const newColumns = []
  for (const loc of locations) {

    if (loc.module_version && loc.module_version.length > 0) {
      for (const version of loc.module_version/*.sort((a, b) => a.module_hwid > b.module_hwid)*/) {

          const newColum = {
            type: "string",
            order: numOrder,  // tmp        

            resizable: false,
            disableReorder: true,

            field: "" + version.module_hwid,
          moduleName: version.module_hwid,
            hide: false,
            width: 250,
            headerName: t('scenarios.modules.' + version.module_hwid + ''),
            align: 'left',
            headerAlign: 'left',
            moduleVersionColumn: true,
            valueGetter: (params) => {
              // console.log("836 - params=", params);
            if (params.row && params.row.module_version && params.row.module_version.length > 0) {

              const found = params.row.module_version.find((element) => {
                  return ("" + element.module_hwid === params.field);
                })
                if (found) {
                return found.version;
                }
                else {
                  return "";
                }
              }
            },
          };
          const found = newColumns.find((element) => {
            return element.field === newColum.field;
          });

          if (found === undefined) {
            newColum.order = numOrder++;
            newColumns.push(newColum);
          }
      }
    }
  }

  // console.log("1685 - newColumns=", newColumns);
  const allColumns = columns.concat(newColumns.sort((a, b) => parseInt(a.field) < parseInt(b.field) ? -1 : 1));
  // console.log("900 - allColumns=", allColumns);
  // console.log("1327 - locations=", locations);
  // console.log("903 - sortModel=", sortModel);
  // console.log("1592 - filterModel=", filterModel);


  const linkOperator = (filterModel && filterModel.items.length > 1) ? (filterModel && filterModel.linkOperator) || "and": "and" ;
  const newFilteredRows = _.filter(locations, row => {

    let keepIt;
    // console.log("-------------------");
    // console.log("903 - row=", row);

    // AND
    if (filterModel && linkOperator === "and") {
      keepIt = true;

      // console.log("906 - filterModel=", filterModel);
      for (const filter of filterModel.items) {

        const values = filter.value && filter.value.split("|");
        // console.log("9926 - values=", values);

        switch (filter.operatorValue) {
          case "contains": {
            if (filter.value) {
              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("990 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    // console.log("998 - value=", value);
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {

                  // console.log("1017 - row[filter.columnField]=", row["email"]);
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {

                  // console.log("1017 - row[filter.columnField]=", row[filter.columnField]);
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          // case "contains": {
          //   if (filter.value && row[filter.columnField] && !row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
          //     keepIt = false;
          //   break;
          // }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() !== filter.value.toUpperCase())
            //   keepIt = false;
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "startsWith": {
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "endsWith": {
            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "isEmpty": {
            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1825 - columnElement=", columnElement, keepIt);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1830 - row.moduleVersion=", row.moduleVersion);
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                    keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
              }
              // else
              //   keepIt = false;

            }
            else if (filter.columnField === "owner") {
              let isThere = false;
              if (row["email"] !== '') {
                isThere = true;
                if (row["email"] !== undefined && row["email"] !== null)
                  keepIt = false;
              }

              if (!isThere)
                keepIt = false;
            }
            else {
              let isThere = false;
              // console.log("1861 - row[filter.columnField]=", row[filter.columnField]);

              if (row[filter.columnField] !== '') {
                // console.log("1863 - row[filter.columnField] !== ''...");

                // if (row[filter.columnField] !== undefined && row[filter.columnField] !== null && row[filter.columnField] !== "") {              
                isThere = true;
                if (row[filter.columnField] !== undefined && row[filter.columnField] !== null) {
                  // console.log("1868 - row[filter.columnField] !== undefined && row[filter.columnField] !== null...");
                  keepIt = false;
              }
              }             

              if (!isThere)
                keepIt = false;
            }

            // console.log("1882 - keepIt=", keepIt);
            break;
          }

          case "isNotEmpty": {
            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1190 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1195 - row.moduleVersion=", row.moduleVersion);

                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  // console.log("1200 -ver=", ver);
                  // console.log("1201 -det=", det);
                  // console.log("1202 -filter=", filter);

                  // console.log("1258 - ver.module_hwid == filter.columnField=", ver.module_hwid == filter.columnField);
                  // console.log("1202 - det[1]=", det[1]);
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                    keepIt = false;
                  }
                }
                if (!isThere)
                  keepIt = false;
              }
              else
                keepIt = false;

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = false;
            }
            else {
              if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
                keepIt = false;
            }
            break;
          }

          default:
            keepIt = true;
        }
      }
    }
    else if (filterModel && linkOperator === "or") {
      keepIt = false;

      // console.log("1001 - filterModel=", filterModel);

      for (const filter of filterModel.items) {
        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "contains": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
            //   keepIt = true;
            // break;

            if (filter.value) {
              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("1230 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
              const found = values.find(value =>
                row[filter.columnField].toUpperCase().includes(value.toUpperCase())
              )
              if (found !== undefined)
                keepIt = true;
            }
              }
            }
            break;

            // if (filter.value) {

            //   const columnElement = allColumns.find((element) => {
            //     return element.field === filter.columnField;
            //   });

            //   const found = values.find(value => {
            //     // console.log("1231 - row=", row);
            //     // console.log("1232 - value=", value);
            //     // row[filter.columnField].toUpperCase().includes(value.toUpperCase())

            //     console.log("998 - value=", value);
            //     for (const ver of row.moduleVersion) {
            //       let det = ver.module_name.split('-');

            //       console.log("1002 - ver=", ver);
            //       console.log("1004 - filter=", filter);
            //       console.log("1005 - det[1]=", det[1]);

            //       if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
            //         return ver;
            //       }
            //     };
            //   });
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;
          }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() === filter.value.toUpperCase())
            //   keepIt = true;
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
              keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "startsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().startsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
              const found = values.find(value =>
                row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
              )
              if (found !== undefined)
                keepIt = true;
            }
              }
            }
            break;
          }

          case "endsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().endsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = allColumns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
              const found = values.find(value =>
                row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
              )
              if (found !== undefined)
                keepIt = true;
            }
              }
            }
            break;
          }

          case "isEmpty": {
            // if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
            //   keepIt = true;

            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1082 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                /*
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                      keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
                */
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');
                  if (ver.module_hwid == filter.columnField) { 
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                      keepIt = true;
                  }
                };
                if (!isThere)
                  keepIt = true;
              }

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = true;
            }
            else {
            if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
              keepIt = true;
            }
            break;
          }

          case "isNotEmpty": {
            // if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
            //   keepIt = true;

            const columnElement = allColumns.find((element) => {
              return element.field === filter.columnField;
            });
            if (columnElement && columnElement.moduleVersionColumn === true) {

              if (row.moduleVersion && row.moduleVersion.length) {
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null && det[1] !== "")
                      keepIt = true;
                  }                  
                }
                if (isThere)
                  keepIt = true;
              }
            }
            else if (filter.columnField === "owner") {
              if (row["email"] !== '' && row["email"] !== undefined && row["email"] !== null)
                keepIt = true;
            }
            else {
            if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
              keepIt = true;
            }
            break;
          }

          default:
            keepIt = false;
        }
      }
    }
    return keepIt;
  });


  // // let currentMovedColumns;
  // React.useEffect(() => {
  //   return apiRef.current.subscribeEvent('columnHeaderDragEnd', (params, a, b, c, d, e, f) => {
  //     // console.log("1281 - params=", params, a, b, c, d, e, f);
  //     // console.log("1282 - columns=", columns);
  //     // console.log("1282 - locationColumnsFromDatabase=", locationColumnsFromDatabase);

  //     // console.log("1282 - targetIndex=", currentMovedColumns[0].oldIndex);
  //     // console.log("1282 - targetIndex=", currentMovedColumns[1].targetIndex);

  //     const newTargetIndex = currentMovedColumns && currentMovedColumns[1] && currentMovedColumns[1].targetIndex;
  //     changeColumnsOrder({ ...currentMovedColumns[0], targetIndex: newTargetIndex });

  //     currentMovedColumns[0] = undefined;
  //   });
  // }, [apiRef]);


  // console.log("1278 - activeGridFilter(t, GridFilterInputValue) }=", activeGridFilter(t, GridFilterInputValue));
  // console.log("856 - selected=", selected);
  // console.log("859 - initialSelectedLocations=", initialSelectedLocations);

  // console.log("1282 - locationColumnsFromDatabase=", locationColumnsFromDatabase);
  // console.log("2052 - allColumns=", allColumns);
  // console.log("2053 - newFilteredRows=", newFilteredRows);

  // console.log("2304 - user=", user);

  let modeLocationText = t('admin.locations.status.' + modeLocations);
  let totalLocationsCount = newFilteredRows.length;

  const newNewFilteredRows = _.filter(newFilteredRows, row => {
    if (modeLocations === 'all_locations') {
      return true;
    }
    else if (modeLocations === 'my_favorite_locations') {
      if (row.favoriteId !== null)
        return true;
    }
    else if (modeLocations === 'my_locations') {
      if (row.owner === user.id)
        return true;
    }
    else if (modeLocations === 'my_production_locations') {
      if (row.owner === user.id && row.status === 'production')
        return true;
    }
    else if (modeLocations === 'my_pilot_locations') {
      if (row.owner === user.id && row.status === 'pilot')
        return true;
    }
    else if (modeLocations === 'my_internal_locations') {
      if (row.owner === user.id && row.status === 'internal')
        return true;
    }
    else if (modeLocations === 'all_production_locations') {
      if (row.status === 'production')
        return true;
    }
    else if (modeLocations === 'all_pilot_locations') {
      if (row.status === 'pilot')
        return true;
    }
    else if (modeLocations === 'all_internal_locations') {
      if (row.status === 'internal')
        return true;
    }
    return false;
  });

  let filteredLocationsCount = newNewFilteredRows.length;

  return (
    <div className="admin">
      <DataGridPro
        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick

        pageSize={settings.pageSize}
        pagination={settings.pagination}
        rows={newNewFilteredRows}
        columns={allColumns}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        columnTypes={{ activeFilter: activeGridFilter(t, GridFilterInputValue) }}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          const r = newNewFilteredRows.find((rowElement) => {
            return rowElement.id === o.id;
          });

          if (r) {
            let forceDisabled = false;
            if (r.owner !== null && user.roleId >= roles.stAdmin) {
              forceDisabled = true;
              if (r.owner === user.id)
                forceDisabled = false;
            }

            if (!forceDisabled && r.exists && r.enabled)
              setSelectedLocation(r);
          }
        }}

        // onColumnWidthChange={col => changeAdminColumns({
        //   column: col.colDef.field, columns: locationColumns, dispatch,
        //   view: 'location', type: 'width', value: col.width
        // })} // Save custom column width set by the user
        // onColumnVisibilityChange={col => changeAdminColumns({
        //   column: col.field, columns: locationColumns, dispatch,
        //   view: 'location', type: 'hide', value: !col.isVisible
        // })} // Save hidden column state set by the user
        // onColumnOrderChange={col => changeAdminColumns({
        //   column: col.field, columns: locationColumns, dispatch,
        //   view: 'location', type: 'order', value: { old: col.oldIndex, new: col.targetIndex }
        // })} // Save custom column order set by the user


        onColumnWidthChange={(params, event) => {
          changeColumnsWidth(params);
        }}
        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}
        onColumnOrderChange={(params, event) => {
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }
          setTargetIndex(params.targetIndex);
        }}

        sortModel={sortModel}
        onSortModelChange={(model) => handleSortChange(model)}

        //filterMode="server"
        //filterModel={filterModel}

        onFilterModelChange={(model) => {
          // console.log('1368 - model=', model);
          setFilterModel(model);
        }}
        disableAddFilterButton={false}

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          ColumnMenu: CustomColumnMenu,
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">
              <h2>
                {/* {t('admin.locations.title')} */}
                <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                  <ul className="dropdown__list" id="modeLocations" style={{ fontSize: "15px" }}>
                    <li
                      onClick={() => handleSetModeLocations('all_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.all_locations')}<br /><br />
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('my_favorite_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.my_favorite_locations')}<br /><br />
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('my_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.my_locations')}
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('my_production_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.my_production_locations')}
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('my_pilot_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.my_pilot_locations')}
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('my_internal_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.my_internal_locations')}<br /><br />
                    </li>

                    <li
                      onClick={() => handleSetModeLocations('all_production_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.all_production_locations')}
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('all_pilot_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.all_pilot_locations')}
                    </li>
                    <li
                      onClick={() => handleSetModeLocations('all_internal_locations')}
                      style={{ textAlign: 'center', padding: '8px 12px' }}
                    >
                      {t('admin.locations.status.all_internal_locations')}
                    </li>
                  </ul>

                  <h2
                    className="dropdown__content"
                    style={{
                      display: "flex",
                      position: "relative",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "0px",
                      marging: "0px 0px 8px 0px",
                      transition: "0.25s",
                      userSelect: "none",
                      textAlign: 'center'
                    }}
                    onClick={() => document.querySelector('#modeLocations').classList.toggle('open')}
                  >
                    <span className="dropdown__open"> </span>
                    <span className="dropdown__open">{modeLocationText}</span>
                    <span
                      className="dropdown__open material-icons-round dropdown__arrow"
                      style={{ padding: "4px 0px 0px 0px" }}
                    >
                      expand_more
                    </span>
                  </h2>
                </div>

                {'\u2000\u2000'}
                <span style={{ color: colors.softthinks, padding: "0px 0px 0px 0px" }}>
                  {loading ? (t('global.loading') + '...') : ((modeLocations === 'all_locations') ? '(' + totalLocationsCount + ')' : '(' + filteredLocationsCount + '/' + totalLocationsCount + ')'  /*apiRef.current.getVisibleRowModels().size*/)}
                </span>
              </h2>

              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton />
                  <GridToolbarColumnsButton />
                </GridToolbarContainer>
                <span className="separation" />

                <div className="actions">
                  <Export
                    apiRef={apiRef}
                    loading={loading}
                    model={model}
                    setModel={setModel}                    
                  /> {/* Excel / PDF Download */}

                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>
                </div>
                <span className="separation" />

                <Button
                  className="button"
                  onClick={() => setSelectedLocation({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('admin.locations.create.button')}
                </Button>


                {/* <Button                 
                  className="button"
                  onClick={() => { 
                    runDebugProcedure();
                   }}
                  startIcon={<span className="material-icons-round">bug_report</span>}
                >
                  {'dEBUG'}
                </Button> */}


              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter />
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}
      {selectedReImportPiceasoft()}

      {showStatistics &&
        <StatisticsDetails
          setShowStatistics={setShowStatistics}
          showStatistics={showStatistics}
        />
      }

      {(locations.length > 0) && <Print locations={rowsToPrint()} />}
    </div>
  );
}
